export const UserCircle2 = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.90334 11.6111C3.77907 10.3319 5.22005 9.50065 6.9987 9.50065C8.77735 9.50065 10.2183 10.3319 11.0941 11.6111M2.90334 11.6111C3.99244 12.5793 5.42689 13.1673 6.9987 13.1673C8.5705 13.1673 10.005 12.5793 11.0941 11.6111M2.90334 11.6111C1.63261 10.4816 0.832031 8.8346 0.832031 7.00065C0.832031 3.5949 3.59294 0.833984 6.9987 0.833984C10.4045 0.833984 13.1654 3.5949 13.1654 7.00065C13.1654 8.8346 12.3648 10.4816 11.0941 11.6111M9.16536 5.66732C9.16536 6.86393 8.19532 7.83398 6.9987 7.83398C5.80208 7.83398 4.83203 6.86393 4.83203 5.66732C4.83203 4.4707 5.80208 3.50065 6.9987 3.50065C8.19532 3.50065 9.16536 4.4707 9.16536 5.66732Z"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
)

export default UserCircle2
